// Logging utility that controls log visibility based on environment
const appInstance = import.meta.env.VITE_APP_ENV;

/**
 * Log messages that should only appear in development and staging environments
 * @param args - Arguments to log
 */
export const logDebug = (...args: unknown[]): void => {
  if (['localhost', 'dev', 'stage', 'docker'].includes(appInstance)) {
    console.debug(...args);
  }
};

/**
 * Log informational messages that should only appear in development and staging environments
 * @param args - Arguments to log
 */
export const logInfo = (...args: unknown[]): void => {
  if (['localhost', 'dev', 'stage', 'docker'].includes(appInstance)) {
    console.info(...args);
  }
};

/**
 * Log warning messages that should only appear in development and staging environments
 * @param args - Arguments to log
 */
export const logWarn = (...args: unknown[]): void => {
  if (['localhost', 'dev', 'stage', 'docker'].includes(appInstance)) {
    console.warn(...args);
  }
};

/**
 * Log error messages that should only appear in development and staging environments
 * @param args - Arguments to log
 */
export const logError = (...args: unknown[]): void => {
  if (['localhost', 'dev', 'stage', 'docker'].includes(appInstance)) {
    console.error(...args);
  }
};

/**
 * Log messages that should appear in all environments including production
 * @param args - Arguments to log
 */
export const logAlways = (...args: unknown[]): void => {
  console.log(...args);
};

export default {
  debug: logDebug,
  info: logInfo,
  warn: logWarn,
  error: logError,
  always: logAlways,
};
